import React,{useState} from 'react';
import * as S from './RnRUserReviewBlock.styles';
import Ratings from '../../../../../../stories/core-components/Ratings/Ratings';
import Icon from './../../../../../../stories/core-components/IconsSelector'
type RnRUserReviewprops = {
  username?: string;
  reviewdate?: string;
  reviewcontent?: string;
  ratingcolor?: string;
  ratingcount?: string;
  liked?: string[];
  operatorReply?: string;
  operatorReplyDate?:string;

};

const RnRUserReviewBlock = ({
  username,
  reviewdate,
  reviewcontent,
  ratingcolor,
  ratingcount,
  liked,
  operatorReply,
  operatorReplyDate

}: RnRUserReviewprops) => {
  const [showOPResponse,setOPResponseView] = useState(false);
  return(
  <S.ReviewBlock>
    <S.NameRating>
      <S.UserName>
        <S.Avatar>
        <Icon name='UserIcon' />
        

        </S.Avatar>
        <S.NameTxt>{username}</S.NameTxt>
      </S.UserName>
      <S.RatingWrap>
        <Ratings color={ratingcolor} ratingCount={ratingcount} />
        <S.ReviewDate>{reviewdate}</S.ReviewDate>
      </S.RatingWrap>
    </S.NameRating>
    <S.ReviewContent>{reviewcontent}</S.ReviewContent>
   {liked && liked.length ? <S.LikeContent>
      <span className="likeTxt">Liked </span>
      <span className="keyTxt">
        - {liked}
      </span>
   </S.LikeContent> :null}
   {operatorReply ? <S.OperatorRespBlock>
      {!showOPResponse ?<S.OpLink onClick={()=>{
        setOPResponseView(!showOPResponse);
      }}>View Bus Operator Response</S.OpLink>:null}
      {showOPResponse ?<S.OpRespBlock>
       {operatorReplyDate ?  <p>Bus Operator Replied, {operatorReplyDate}</p> :null}
        <p>{operatorReply}</p>
      </S.OpRespBlock> :null}
    </S.OperatorRespBlock>:null}
  </S.ReviewBlock>
);
   }
export default RnRUserReviewBlock;
